import { InteractionRequiredAuthError } from '@azure/msal-browser'
import { config, isEntraConfigured } from '../config'
import { apiRequest, msalInstance } from './msal'

/** localStorage-nøgle til det lokale login-token (brugere uden Microsoft 365). */
export const LOCAL_TOKEN_KEY = 'tcpss.localToken'

export function readLocalToken() {
  try {
    return localStorage.getItem(LOCAL_TOKEN_KEY)
  } catch {
    return null
  }
}

/**
 * Headers for den indloggede bruger: lokalt token først, så dev-login uden Entra ID,
 * og ellers Microsoft-tokenet.
 *
 * Bruges både af adminpanelet og af TV-forhåndsvisningen (beslutning 087). Før havde
 * forhåndsvisningen sin egen kopi, som ikke kendte det lokale token - en lokal bruger
 * fik derfor "Ingen forbindelse" i stedet for sit dashboard.
 *
 * `redirectOnInteraction`: kun adminpanelet sender brugeren videre til Microsoft, når
 * sessionen ikke kan fornyes stille. En forhåndsvisning skal bare sige, at login mangler.
 */
export async function userAuthHeaders(options: { redirectOnInteraction: boolean }): Promise<Record<string, string>> {
  const localToken = readLocalToken()
  if (localToken) {
    return { Authorization: `Bearer ${localToken}` }
  }

  if (!isEntraConfigured || !msalInstance) {
    // Udviklingstilstand uden Entra ID.
    return config.devUser ? { 'X-Dev-User': config.devUser } : {}
  }

  const account = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0]
  if (!account) {
    return {}
  }

  try {
    const result = await msalInstance.acquireTokenSilent({ ...apiRequest, account })
    return { Authorization: `Bearer ${result.accessToken}` }
  } catch (err) {
    if (options.redirectOnInteraction && err instanceof InteractionRequiredAuthError) {
      // Sessionen kan ikke fornyes uden brugerinteraktion - send brugeren til login.
      await msalInstance.acquireTokenRedirect({ ...apiRequest, account })
    }
    return {}
  }
}
